<template>
  <div
    :class="`col-md-${configuration.size} ${isAdmin?'admin':''}`"
    class="blockItem mb-3 d-flex justify-content-between "
    style="flex-direction: column;  "
  >
    <div>
      <span
        v-if="!input.visible"
        class="text-danger"
      >{{ $t('vendorManagmentInputView.istifadilrBuBlokuGrmrlr') }}</span>

      <div
        v-if="input.title"
        class="font-weight-bold "
      >
        {{ input.title }}
        <span
          v-if="input.required"
          class="text-danger"
        >*</span>
      </div>
      <div
        v-if="input.description"
        class="text-gray mb-2"
      >
        {{ input.description }}
      </div>
    </div>
    <div
      class="my-2"
      style=" margin-top: auto"
    >
      <div v-if="input.inputType ==='string'">
        <input
          v-model="inputValue"
          type="text"
          class="form-control"
          :required="input.required"
        >
      </div>
      <div v-else-if="input.inputType ==='number'">
        <input
          v-model="inputValue"
          type="number"
          class="form-control"
          :required="input.required"
        >
      </div>
      <div v-else-if="input.inputType ==='longtext'">
        <textarea
          v-model="inputValue"
          rows="5"
          class="form-control"
          :required="input.required"
        />
      </div>
      <div v-else-if="input.inputType ==='email'">
        <input
          v-model="inputValue"
          type="email"
          class="form-control"
          :required="input.required"
        >
      </div>
      <div v-else-if="input.inputType ==='url'">
        <input
          v-model="inputValue"
          type="text"
          class="form-control"
          :required="input.required"
          placeholder="https://example.com/path"
        >
      </div>
      <div v-else-if="input.inputType ==='phone'">
        <VuePhoneNumberInput
          v-model="phoneNumber"
          :default-country-code="'AZ'"
          :only-countries="['AZ']"
          :required="input.required"
          :no-example="true"
          @update="phoneUpdated($event)"
          @phone-number-blur="phoneBlur($event)"
        />
      </div>
      <div v-else-if="input.inputType ==='date'">
        <datepicker
          v-model="inputValue"
          :name="`input_${input.id}`"
          :required="input.required"
          input-class="datepicker-here form-control digits"
          :format="dateFormat"
        />
      </div>

      <div v-else-if="input.inputType ==='daterange'">
        <date-range-picker
          ref="picker"
          v-model="dateRange"
          class="w-100"
          opens="right"
          :ranges="false"
          :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
          :time-picker="false"
          :linked-calendars="true"
          :auto-apply="true"
          :date-format="dateFormatDateRange"
          @update="dateRangeSelected($event)"
        >
          <template
            #input="picker"
            style="min-width: 350px;"
          >
            {{ $t('vendorManagmentInputView.key', {moment: getMoment(picker.startDate) , moment_2: getMoment(picker.endDate)}) }}
          </template>
        </date-range-picker>
      </div>

      <div v-else-if="input.inputType ==='select'">
        <Multiselect
          v-model="selectedValue"
          :name="`input_${input.id}`"
          :options="selectValue"
          :multiple="configuration.multiple"
          :taggable="false"
          :allow-empty="!input.required"
        />
      </div>
      <div v-else-if="input.inputType ==='file'">
        <vue2Dropzone
          id="dropzone"
          ref="fileDropzone"
          :options="uploadOptions"
          @vdropzone-sending="uploadEvent"
          @vdropzone-complete="fileAdded"
          @vdropzone-removed-file="fileRemoved"
        />
      </div>
    </div>


    <div
      v-if="isAdmin"
      class="actions"
    >
      <a
        class="btn btn-sm btn-primary m-1 px-2"
        :title="$t('vendorManagmentInputView.blokuRedaktEt')"
        @click="$emit('edit')"
      >
        <feather
          type="edit-2"
          size="12"
        />
      </a>
      <a
        class="btn btn-sm btn-danger m-1 px-2"
        :title="$t('vendorManagmentInputView.blokuSil')"
        @click="$emit('delete')"
      >
        <feather
          type="x"
          size="12"
        />
      </a>
      <a
        class="btn btn-sm btn-success m-1 px-2"
        :title="$t('vendorManagmentInputView.buBlokuKopyala')"
        @click="$emit('copy')"
      >
        <feather
          type="copy"
          size="12"
        />
      </a>
      <a
        class="btn btn-sm btn-dark m-1 px-2"
        :title="$t('vendorManagmentInputView.buBlokdanSonraYeniBlokLavEt')"
        @click="$emit('addAfter')"
      >
        <feather
          type="plus"
          size="12"
        />
      </a>
    </div>
  </div>
</template>
<script>


import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import {mapState} from "vuex";
import {baseUrl, mediaBase} from "@/repositories/Repository";

import moment from "moment";

export default {
  name: 'VendorManagementInputView',
  props: [
    'input',
    'isAdmin',
    'modelValue'
  ],
  emits: ['update:modelValue'],
  data() {
    return {
      mediaBase: mediaBase,
      apiBase: baseUrl,
      configuration: {},
      dateFormat: "dd/MM/yyyy",
      uploadedFiles: [],
      selectedValue: '',
      phoneNumber: '',
      phoneObject: null,
      dateRange: {
        startDate: null,
        endDate: null
      }
    }
  },
  watch: {
    uploadedFiles(newVal) {
      this.$emit('update:modelValue', newVal.join(','))
    },
    phoneNumber(newVal) {
      // this.$emit('update:modelValue', newVal)
    },
    selectedValue(newVal) {
      console.log("select value update");
      console.log(newVal);
      this.$emit('update:modelValue', newVal)
    },
    modelValue() {
      this.checkModelValue();
    }
  },
  computed: {
    ...mapState({
      token: state => {
        return state.auth.token
      }
    }),

    inputValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    uploadPath() {
      return `${baseUrl}/user/upload`;
    },
    uploadOptions() {
      return {
        url: this.uploadPath, // this just demo url we want to change it
        thumbnailHeight: 150,
        thumbnailWidth: 150,
        maxFilesize: this.configuration.multiple ? 5 : 1,
        withCredentials: false,
        headers: {
          token: this.token,
          "Cache-Control": "",
          "X-Requested-With": "",
        },
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> <br> fayl yüklə",
        dictRemoveFile: "sil"
      };
    },
    selectValue() {
      if (this.input.inputType === 'select') {
        return this.configuration.values.split('\n')
      }
      return [];
    },


  },
  created() {
    this.configuration = JSON.parse(this.input.settings);
  },

  mounted() {

    this.checkModelValue();
  },
  methods: {
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    dateRangeSelected() {
      console.log(this.dateRange.startDate);
      console.log(moment(this.dateRange.startDate));
      let dates = moment(this.dateRange.startDate).format('YYYY-MM-DD')+" - "+moment(this.dateRange.endDate).format('YYYY-MM-DD');
      this.$emit('update:modelValue', dates);
    },
    dateFormatDateRange(classes, date) {

      return classes
    },
    phoneUpdated(event) {
      this.phoneObject = event;
      if (event.isValid) {
        this.$emit('update:modelValue', event.formattedNumber);
      }
    },
    phoneBlur() {
      if (this.phoneObject && this.phoneObject.isValid) {
        this.$emit('update:modelValue', this.phoneObject.formattedNumber);
      } else {
        this.$emit('update:modelValue', '');
        this.phoneNumber = '';
      }
    },
    uploadEvent(file, xhr, formData) {
      formData.append('type', 'vendorManagement');
    },
    fileAdded(upload) {

      if (upload.manuallyAdded) {
        //nothing todo
      } else if (upload.status === 'success') {
        let res = JSON.parse(upload.xhr.response);
        this.uploadedFiles.push(res.path);
      } else {
        this.$refs.fileDropzone.removeFile(upload)

        this.$swal({
          title: this.$t("err"),
          text: `Fayl yüklənə bilmədi`,
          icon: 'error'
        })
      }

    },
    fileRemoved(upload) {
      if (upload.status === 'success') {
        let res = JSON.parse(upload.xhr.response);
        let index = this.uploadedFiles.indexOf(res.path);
        if (index > -1) {
          this.uploadedFiles.splice(index, 1);
        }
      }
    }
    ,
    checkModelValue() {

      if (this.input.inputType === 'file') {

        if (this.modelValue && this.modelValue !== '') {

          this.uploadedFiles = this.modelValue.split(',');

          this.uploadedFiles.forEach((f, j) => {
            var url = this.mediaBase + "" + f;
            let ext = f.split('.').pop();
            let file = {};
            if (this.isPhoto(f)) {
              file = {size: 1000, name: "Photo", type: "image/" + ext};
            } else {
              file = {size: 1000, name: "File", type: "file/" + ext};
            }

            this.$refs.fileDropzone.manuallyAddFile(file, url);
          });

        }

      } else if (this.input.inputType === 'phone') {
        this.phoneNumber = this.modelValue;
      } else if (this.input.inputType === 'select') {
        this.selectedValue = this.modelValue;
      } else if (this.input.inputType === 'daterange') {

        if(!this.modelValue){
          return;
        }
        let parts = this.modelValue.split(' - ');

        this.dateRange= {
          startDate: moment(parts[0]).toDate(),
          endDate: moment(parts[1]).toDate()
        };
      }
    }
  },
  components: {Multiselect, Datepicker, vue2Dropzone, VuePhoneNumberInput, DateRangePicker}

}
</script>
<style lang="scss" scoped>
.blockItem {
  position: relative;
  padding: 10px 15px;

  .actions {
    position: absolute;
    right: 10px;
    top: 10px;
    display: none;
  }

  &.admin {
    border: 1px dashed #e7e6e6;
  }


  &:hover {
    &.admin {
      border-color: #888888;
      box-shadow: 0 0 2px #0b2e13;

      .actions {
        display: block;
      }
    }
  }


}

::v-deep .dropzone {
  min-height: 50px !important;
}


::v-deep .dropzone .dz-default.dz-message {
  width: auto !important;
}


/*
::v-deep .dz-remove{
  opacity: 1 !important;
}*/
</style>
